export default "__VITE_ASSET__69293dd5__"